import { Routes, Route, Navigate } from "react-router-dom";
import { MemberProvider } from "@/training/MemberContext";
import { MemberShell, TrainingHead } from "@/training/TrainingShell";
import Landing from "@/training/pages/Landing";
import Login from "@/training/pages/Login";
import Register from "@/training/pages/Register";
import ResetPassword from "@/training/pages/ResetPassword";
import ParentConsent from "@/training/pages/ParentConsent";
import Dashboard from "@/training/pages/Dashboard";
import Library from "@/training/pages/Library";
import ExerciseDetail from "@/training/pages/ExerciseDetail";
import Favorites from "@/training/pages/Favorites";
import Profile from "@/training/pages/Profile";
import Plan from "@/training/pages/Plan";
import Membership, { PaymentResult } from "@/training/pages/Membership";
import { More, Live, Challenges } from "@/training/pages/Community";
import Nutrition from "@/training/pages/Nutrition";

export default function TrainingApp() {
  return (
    <MemberProvider>
      <TrainingHead />
      <Routes>
        <Route index element={<Landing />} />
        <Route path="login" element={<Login />} />
        <Route path="registrieren" element={<Register />} />
        <Route path="passwort/:token" element={<ResetPassword />} />
        <Route path="eltern/:token" element={<ParentConsent />} />
        <Route element={<MemberShell />}>
          <Route path="start" element={<Dashboard />} />
          <Route path="plan" element={<Plan />} />
          <Route path="mitgliedschaft" element={<Membership />} />
          <Route path="zahlung" element={<PaymentResult />} />
          <Route path="mehr" element={<More />} />
          <Route path="live" element={<Live />} />
          <Route path="challenges" element={<Challenges />} />
          <Route path="ernaehrung" element={<Nutrition />} />
          <Route path="bibliothek" element={<Library />} />
          <Route path="favoriten" element={<Favorites />} />
          <Route path="profil" element={<Profile />} />
        </Route>
        <Route path="uebung/:slug" element={<ExerciseDetail />} />
        <Route path="*" element={<Navigate to="/training" replace />} />
      </Routes>
    </MemberProvider>
  );
}
